export const RIGHT_PANEL_TRANSITION = {
    duration: 0.38,
    ease: [0.16, 1, 0.3, 1],
};

export const TOPBAR_HEIGHT_PX = 56;
export const TOPBAR_XL_HEIGHT_PX = 60;

export const TOPBAR_HEIGHT_SX = {
    xs: TOPBAR_HEIGHT_PX,
    xl: TOPBAR_XL_HEIGHT_PX,
};

export const APP_SHELL_TOP_OFFSET_SX = {
    xs: `calc(${TOPBAR_HEIGHT_PX}px + 1.5rem)`,
    xl: `calc(${TOPBAR_XL_HEIGHT_PX}px + 1.5rem)`,
};

export const NAV_SIDEBAR_HEIGHT_SX = {
    xs: `calc(100vh - ${TOPBAR_HEIGHT_PX}px - 1.5rem - 1.5rem)`,
    xl: `calc(100vh - ${TOPBAR_XL_HEIGHT_PX}px - 1.5rem - 2rem)`,
};

export const MAIN_SECTION_MIN_HEIGHT_SX = NAV_SIDEBAR_HEIGHT_SX;

/** Matches plan: fixed bottom nav at max-width 768px */
export const MOBILE_NAV_MEDIA = "(max-width:768px)";

/** Short viewports (mobile landscape) — avoid forcing full-viewport stretch */
export const SHORT_VIEWPORT_MEDIA = "(max-height:520px)";

/** Icon-row chrome height (excludes safe-area padding) */
export const MOBILE_NAV_HEIGHT = "4.25rem";

/** Space between the top of the nav and floating UI (feedback FAB, etc.) */
export const MOBILE_NAV_FAB_GAP = "0.75rem";

/**
 * Bottom clearance for main content:
 * nav chrome + safe-area (bar is flush to the viewport bottom).
 */
export const MOBILE_NAV_BOTTOM_INSET = `calc(${MOBILE_NAV_HEIGHT} + env(safe-area-inset-bottom, 0px))`;

/** Bottom offset so FABs sit above the attached nav, not over it */
export const MOBILE_NAV_FAB_BOTTOM = `calc(${MOBILE_NAV_HEIGHT} + ${MOBILE_NAV_FAB_GAP} + env(safe-area-inset-bottom, 0px))`;
